module.exports = __webpack_public_path__ + "media/images/avatar/04-aefc07e6d0ed3e0bc6c203d38556b1b2.jpg";